import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'

import { Text } from 'components/dataDisplay'
import { Href } from 'components/navigation'
import noPhotoImg from 'components/dataDisplay/Image/images/noPhoto72.svg'

import s from './ModuleCard.scss'


const ModuleCard = (props) => {
  const { className, icon, title, text, appeals, appealsCount, link } = props

  const { isMobile } = useDevice()

  const appealsNode = appeals && appealsCount > 0 && (
    <div className="flex items-center">
      <div className={cx(s.appealThumbnails, 'relative')}>
        {
          appeals.map(({ image }, index) => (
            <img key={index} src={image || noPhotoImg} width="56" height="56" alt="appeal thumbnail" />
          ))
        }
      </div>
      <Text
        className={cx(s.appealsCountText, 'opacity-48 ml-8px whitespace-pre')}
        message={`В работе\n${appealsCount} обращения`}
        size="s13-r"
      />
    </div>
  )

  return (
    <Href className={cx(className, s.root, 'flex flex-col radius-24 px-24px pb-24px')} to={link}>
      <div className="flex justify-between">
        <img className={cx(s.icon)} srcSet={icon + ' 2x'} alt="icon" />
        {
          !isMobile && (
            <div className="mt-24px">
              {appealsNode}
            </div>
          )
        }
      </div>
      <div className="mt-16px">
        <Text
          message={title}
          size="h24"
        />
        <Text
          className="opacity-72 mt-8px"
          message={text}
          size="t16-24"
        />
      </div>
      {
        isMobile && (
          <div className="mt-16px">
            {appealsNode}
          </div>
        )
      }
    </Href>
  )
}

export default ModuleCard